<template>
  <div class="stopEmails container has-text-centered">
    <h1 class="title is-4 is-font-sans is-color-pff-light-blue">
      Unsubscribe / Stop Emails
    </h1>
    <div v-if="status == 'no email'">
      <div class="notification is-danger">
        <router-link class="delete" to="/"></router-link>
        Invalid email: We are unable to process your request. Please try again
        or contact us for further assistance.
      </div>
    </div>
    <div v-else-if="status == 'unsubscribed'">
      <div class="notification is-success">
        <router-link class="delete" to="/"></router-link>
        Unsubscribed - we have added
        <strong
          ><u>{{ this.$route.params.email_address }}</u></strong
        >
        to our stop emails list and no further emails will be sent from the
        MyFundraisingPersonality.com website.
      </div>
    </div>
    <div class="isLoading" v-else>
      <div class="wrapper" id="loadingAnimation">
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="circle"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
        <div class="shadow"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from "../components/firebase.init";

export default {
  name: "StopEmails",

  data() {
    return {
      status: "loading",
      email: this.$route.params.email_address.toLowerCase()
    };
  },

  created() {
    if (this.$route.params.email_address) {
      db.collection("stopEmails")
        .add({
          time: new Date(Date.now()),
          email: this.email
        })
        .then(querySnapshot => {
          this.status = "unsubscribed";
        })
        .catch(error => {
          this.status = "no email";
          console.log(error);
        });
    } else {
      this.status = "no email";
    }
  }
};
</script>

<style scoped>
.stopEmails {
  text-align: center;
  padding: 10vh 2rem 0 2rem;
}

.isLoading {
  text-align: center;
  padding-top: 30vh;
  padding-left: 42vw;
}

@media only screen and (max-width: 600px) {
  .isLoading {
    text-align: center;
    padding-top: 30vh;
    padding-left: 40vw;
  }
}
</style>
